import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface AppState {
  activeTraegerId: string | null;
  activeEinrichtungId: string | null;
  activeFoerderjahr: number;
  setTraeger: (id: string | null) => void;
  setEinrichtung: (id: string | null) => void;
  setFoerderjahr: (year: number) => void;
}

const currentYear = new Date().getFullYear();

export const useAppStore = create<AppState>()(
  persist(
    (set) => ({
      activeTraegerId: null,
      activeEinrichtungId: null,
      activeFoerderjahr: currentYear,
      setTraeger: (id) => set({ activeTraegerId: id, activeEinrichtungId: null }),
      setEinrichtung: (id) => set({ activeEinrichtungId: id }),
      setFoerderjahr: (year) => set({ activeFoerderjahr: year }),
    }),
    {
      name: 'lft.app-state',
      version: 1,
    },
  ),
);
